<template>
  <v-row class="color-code mx-12">
    <v-col
      class="d-flex justify-content-end"
      cols="12"
    >
      <div class="d-flex ml-5">
        <div class="degree-1 ml-2" />
        <span class="degree-text fi"> {{ local.grades.first }}</span>
      </div>

      <div class="d-flex ml-5">
        <div class="degree-2 ml-2" />
        <span class="degree-text appeal"> {{ local.grades.appeal }}</span>
      </div>

      <div class="d-flex ml-5">
        <div class="degree-3 ml-2" />
        <span class="degree-text higher"> {{ local.grades.higher }}</span>
      </div>
    </v-col>
  </v-row>
</template>

<script>
export default { name: 'DegreeColorPalette' };
</script>

<style lang="scss" scoped>
    .color-code {
        .degree-text {
            font-size: 16px;
            font-weight: bold;

            &.fi {
                color: var(--app-lighter-primary-color);
            }

            &.appeal {
                color: var(--app-primary-color);
            }

            &.higher {
                color: var(--app-dark-primary-color);
            }
        }

        .degree-1 {
            width: 20px;
            height: 20px;
            background-color: var(--app-lighter-primary-color);
        }

        .degree-2 {
            width: 20px;
            height: 20px;
            background-color: var(--app-primary-color);
        }

        .degree-3 {
            width: 20px;
            height: 20px;
            background-color: var(--app-dark-primary-color);
        }
    }
</style>